import { useEffect, useState, useRef } from 'react';
import { useRecoilState } from 'recoil';
import { 
    newTaskConfig,
    selectedBaseModelState,
    selectedModelState,
    selectedModelBestState,
    isModelDirScrollState,
    namespaceState 
} from '../../../recoil/atoms';
import styles from './style.module.css'
import ToolTip from '../../../compoenets/ToolTip';
import ContextMenu from '../../../compoenets/ContextMenu';
import useApi from '../../../services/useApi';
import { taskConfigDefault } from '../../../constants';
import ViewNavigate from '../../../utils/ViewNavigate';
import { useNavigate } from 'react-router-dom';
import ValidModal from './ValidModal';

const Node=({data,onChange})=>{
    const [selectedBaseModel, ]=useRecoilState(selectedBaseModelState);
    const [selectedModel, ]=useRecoilState(selectedModelState);
    const [, setSelectedModelBest]=useRecoilState(selectedModelBestState);
    const [isModelDirScroll, setIsModelDirScroll]=useRecoilState(isModelDirScrollState);
    const [isOpen,setIsOpen]=useState(false);
    const nodeRef=useRef(null);
    const roundRefs=useRef([]);
    const [bestTrainLoss,setBestTrainLoss]=useState(null);
    const [bestEvalLoss,setBestEvalLoss]=useState(null);
    const [bestAcc,setBestAcc]=useState(null);
    const [bestMae,setBestMae]=useState(null);
    const [bestMse,setBestMse]=useState(null);
    const [bestRmse,setBestRmse]=useState(null);

    const [,setTaskConfig] = useRecoilState(newTaskConfig);
    const [nsState,setNsState]=useRecoilState(namespaceState);
    const userId=JSON.parse(localStorage.getItem("account")).id;

    useEffect(()=>{
        let newTrainLoss=null;
        let newEvalLoss=null;
        let newAcc=null;
        let newMae=null;
        let newMse=null
        let newRmse=null;

        data.rounds.forEach(item=>{
            const {loss:evalLoss,accuracy:acc,mae,mse,rmse}=item.evaluationResult||{};
            const {loss:trainLoss}=item.trainingResult||{};

            if(trainLoss!==undefined&&(newTrainLoss===null||trainLoss<newTrainLoss.value)){
                newTrainLoss={
                    value:trainLoss,
                    roundNum:item.roundNum
                }
            }

            if(evalLoss!==undefined&&(newEvalLoss===null||evalLoss<newEvalLoss.value)){
                newEvalLoss={
                    value:evalLoss,
                    roundNum:item.roundNum
                }
            }

            if(acc!==undefined&&(newAcc===null||acc>newAcc.value)){
                newAcc={
                    value:acc,
                    roundNum:item.roundNum
                }
            }

            if(mae!==undefined&&(newMae===null||mae>newMae.value)){
                newMae={
                    value:mae,
                    roundNum:item.roundNum
                }
            }

            if(mse!==undefined&&(newMse===null||mse>newMse.value)){
                newMse={
                    value:mse,
                    roundNum:item.roundNum
                }
            }

            if(rmse!==undefined&&(newRmse===null||rmse>newRmse.value)){
                newRmse={
                    value:rmse,
                    roundNum:item.roundNum
                }
            }
        })

        setBestTrainLoss(newTrainLoss)
        setBestEvalLoss(newEvalLoss)
        setBestAcc(newAcc)
        setBestMae(newMae)
        setBestMse(newMse)
        setBestRmse(newRmse)

        // if(!selectedModel.task) return;
        // if(selectedModel.task.taskId===data.taskId){
        //     setIsOpen(true);
            // const observe=new MutationObserver(()=>{
            //     if(roundRefs.current[selectedModel.task.roundNum]){
            //         roundRefs.current[selectedModel.task.roundNum].scrollIntoView({
            //             behavior:'smooth',
            //             block:'center'
            //         })
            //         observe.disconnect();
            //     }
            // })

            // observe.observe(roundRefs.current[selectedModel.task.roundNum],{
            //     childList:true,
            //     subtree:true,
            // })
            // return ()=>observe.disconnect();
        // }
    },[])

    useEffect(()=>{
        // if(!isModelDirScroll)return;
        if(selectedModel.task?.taskId!==data.taskId)return;
        if(isOpen){
            roundRefs.current[selectedModel.task.roundNum].scrollIntoView({behavior:'smooth',block:'center'})
        }else{
        setIsOpen(true);
        const scrollTimeout=setTimeout(() => {
            if(roundRefs.current[selectedModel.task.roundNum]){
                roundRefs.current[selectedModel.task.roundNum].scrollIntoView({behavior:'smooth',block:'center'})
            }
            setIsModelDirScroll(false);
        }, 600);
        return ()=>clearTimeout(scrollTimeout);
        }
    },[selectedModel])

    const handleChange=(modelId)=>{
        onChange(modelId)
        setSelectedModelBest({
            bestTrainLoss:bestTrainLoss,
            bestEvalLoss:bestEvalLoss,
            bestAcc:bestAcc,
            bestMse:bestMse,
            bestMae:bestMae,
            bestRmse:bestRmse,
        })
    }

    const navigate=ViewNavigate(useNavigate(),'/new-task-device');
    const handleNewTask=(e,modelData)=>{
        e.stopPropagation();
        setTaskConfig((prevData) => ({
            ...prevData,
            requiredData: selectedBaseModel.dataset,
            initialModelId:modelData.modelId,
            initialModelName:"taskID-"+data.taskId+"-roundNum-"+modelData.roundNum,
        }));
        navigate();
    }

    const pinToAvailableModel=(modelData) => {
        const data = {
            model: {
                modelId: modelData.modelId,
                namespaceId: nsState.id,
                userId: userId,
                userTags: [
                    "onList"
                ]
            }
        }

        useApi.post('/ngp/modelreg/mm/model/v1/model/usertag', data)
        .then((res) => {
            alert("Pinning was successful")
        })
    }

    return(
        <div 
        ref={nodeRef}
        className={styles['node']} key={data.taskId}>
            <div className={`${styles['node-task']} ${isOpen&&styles['node-task-open']}`}
            onClick={()=>setIsOpen(!isOpen)}>
                <ToolTip className={styles['node-task-name']}><span>{data.taskName?data.taskName:data.taskId}</span></ToolTip>
                <ContextMenu
                renderBtn={({ref, onClick})=>(
                    <button ref={ref} className={styles['node-menu-task']} onClick={onClick}></button>
                )} 
                renderMenu={()=>(
                    <>
                        <span className={`${styles['context-item']} ${styles['task-context-item']}`}>Task Detail</span>
                        <span className={`${styles['context-item']} ${styles['task-context-item']}`}>Copy</span>
                    </>
                )}
                />
            </div>
            {isOpen&&
            <div 
            className={styles['node-body']}>
                {data.rounds.map(item=>
                <div
                key={item.modelId}
                ref={(el)=>roundRefs.current[item.roundNum]=el}
                className={`${styles['node-round']} ${item.modelId===selectedModel.modelId&&styles['node-round-selected']}`}
                onClick={()=>handleChange(item.modelId)}>
                    <p>
                        <span>{item.roundNum===0?'Initial Model':item.roundNum+' Round'}</span>
                        {item.roundNum>data.maxRound&&<span>Test</span>}
                        {((bestAcc?.roundNum)===(bestTrainLoss?.roundNum)&&(bestTrainLoss?.roundNum===item.roundNum))
                        ? <span>Best Loss & Acc</span>
                        :<>
                            {bestTrainLoss?.roundNum===item.roundNum&&<span>Best Loss</span>}
                            {bestAcc?.roundNum===item.roundNum&&<span>Best Acc</span>}
                        </>}
                    </p>
                    <ContextMenu
                    menuShow={true}
                    renderBtn={({ref, onClick}) => (
                            <button ref={ref} className={styles['node-menu']} onClick={onClick}></button>
                    )} 
                    renderMenu={()=>(
                        <>
                            <span className={`${styles['context-item']} ${styles['round-context-item']}`} onClick={(e)=>handleNewTask(e,item)}>New Task</span>
                            <span className={`${styles['context-item']} ${styles['round-context-item']}`} onClick={()=>{pinToAvailableModel(item)}}>Pin to available model</span>
                            <span className={`${styles['context-item']} ${styles['round-context-item']}`} onClick={()=>{}}>Task Detail</span>
                            <span className={`${styles['context-item']} ${styles['round-context-item']}`} onClick={()=>{}}>Download</span>
                        </>
                    )} 
                    />
                </div>
                )}
            </div>
            }
        </div>
    )
}

export default function ModelDirectory({className,onChange}){

    const [selectedBaseModel, setSelectedBaseModel]=useRecoilState(selectedBaseModelState);
    const [selectedModel, setSelectedModel]=useRecoilState(selectedModelState);
    const [nsState,setNsState]=useRecoilState(namespaceState);
    const [,setTaskConfig] = useRecoilState(newTaskConfig);
    const userId=JSON.parse(localStorage.getItem("account")).id;

    const [dirData,setDirData]=useState(null);
    const [isValid,setIsValid]=useState(false);

    useEffect(()=>{
        useApi.get('/ngp/modelreg/mm/model/v1/directories?namespaceId='+nsState.id+'&userId='+userId+'&modelId='+selectedBaseModel.modelId+'&pageSize='+100)
        .then((res) => {
            setDirData(res.data)
        })

        setTaskConfig(taskConfigDefault);
    },[])

    const handleSearch=()=>{

    }

    const handleBaseMenu=()=>{

    }

    const handleValid=(e)=>{
        e.stopPropagation();
        setIsValid(true);
    }

    return(
        <>
        <div className={`${styles['wrap']} ${className}`}>
            <div className={styles['header']}>
                <span>Model Directory</span>
                {/* <div
                className={styles['search']}
                onClick={handleSearch}>
                </div> */}
            </div>
            <div className={styles['body']}>
                <div 
                className={`${styles['node-base']} 
                            ${selectedBaseModel.modelId===selectedModel.modelId&&styles['node-selected']}`}
                onClick={()=>onChange(selectedBaseModel.modelId)}>
                    <span>{selectedBaseModel.name}</span>
                    <ContextMenu
                    menuShow={true}
                    renderBtn={({ref, onClick})=>(
                        <button ref={ref} className={styles['node-menu']} onClick={onClick}></button>
                    )} 
                    renderMenu={()=>(
                        <>
                            <span className={`${styles['context-item']} ${styles['base-context-item']}`}>New Task</span>
                            <span 
                            className={`${styles['context-item']} ${styles['base-context-item']}`}
                            onClick={handleValid}>
                                Validation
                            </span>
                            <span className={`${styles['context-item']} ${styles['base-context-item']}`}>Download</span>
                        </>
                    )}
                    />
                </div>
                {dirData?.items.map(item=><Node 
                data={item}
                onChange={(modelId)=>onChange(modelId)}
                />)}
            </div>
        </div>
        {isValid&&<ValidModal
        onClose={()=>setIsValid(false)}
        />}
        </>
    )
}